import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

const STORAGE_KEY = "zelvoniq_cookie_consent_v1";

const setGoogleConsent = (granted) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const state = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    analytics_storage: state,
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  });
};

export const CookieBanner = () => {
  const { t, localizedPath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (!saved) {
      setVisible(true);
    } else if (saved === "accepted") {
      setGoogleConsent(true);
    }
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem(STORAGE_KEY, "accepted");
    setGoogleConsent(true);
    setVisible(false);
  };

  const handleReject = () => {
    window.localStorage.setItem(STORAGE_KEY, "rejected");
    setGoogleConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-[#C85A32] bg-white shadow-[0_-8px_24px_rgba(15,44,89,0.15)]"
      role="dialog"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="max-w-3xl">
          <p className="mb-1 text-sm font-semibold text-[#0F2C59]">
            {t("cookie_banner.title")}
          </p>
          <p className="text-sm leading-relaxed text-slate-600">
            {t("cookie_banner.description")}{" "}
            <Link
              to={localizedPath("/cookie-policy")}
              data-testid="cookie-banner-learn-more"
              className="font-semibold text-[#0F2C59] underline underline-offset-2 hover:text-[#C85A32]"
            >
              {t("cookie_banner.learn_more")}
            </Link>
          </p>
        </div>
        <div className="flex flex-shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={handleReject}
            data-testid="cookie-reject-button"
            className="rounded-sm border border-slate-300 px-4 py-2 text-sm font-semibold text-[#0F2C59] hover:bg-slate-100"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            data-testid="cookie-accept-button"
            className="rounded-sm bg-[#0F2C59] px-4 py-2 text-sm font-semibold text-white hover:bg-[#153970]"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
